import React from 'react';
import {StyleSheet, View} from 'react-native';
import CCText from '@/Atoms/CCText';
import {lbColors} from '../leaderboardTheme';
import {MeVM, PeriodMeta} from '../types';
import PlayerAvatar from './PlayerAvatar';

interface Props {
  me: MeVM;
  topN: number;
  // Drives the metric word ("wins" vs "days" on the Top Streaks tab); falls
  // back to "wins" wording when omitted so pre-engagement callers are unaffected.
  meta?: PeriodMeta;
}

/** Sticky dark bottom bar shown on narrow screens when outside the top N. */
export default function StickyYourRankBar({me, topN, meta}: Props) {
  const metricWord = meta?.metricLabel === 'DAYS' ? 'days' : 'wins';
  const oneMore = metricWord === 'days' ? '1 more day' : '1 more win';
  const nMore =
    metricWord === 'days'
      ? `${me.winsToEnterTop} more days`
      : `${me.winsToEnterTop} more wins`;
  const sub =
    me.rank != null
      ? `${
          me.winsToEnterTop === 1 ? oneMore : nMore
        } to climb into the top ${topN}`
      : `Win a game to enter the leaderboard`;

  return (
    <View style={styles.stickyBar}>
      <CCText
        fontSize={16}
        fontWeight="bold"
        color={lbColors.gold}
        style={styles.stickyRank}>
        {me.rank != null ? `#${me.rank}` : '—'}
      </CCText>
      <PlayerAvatar
        initials={me.initials}
        color={lbColors.teal}
        avatarUrl={me.avatarUrl}
        size={38}
        ring={lbColors.gold}
      />
      <View style={styles.middle}>
        <CCText fontSize={15} fontWeight="bold" color="#FFFFFF">
          You
        </CCText>
        <CCText fontSize={12} fontWeight="semibold" color={lbColors.darkText}>
          {sub}
        </CCText>
      </View>
      <View style={styles.winsWrap}>
        <CCText fontSize={20} fontWeight="bold" color="#FFFFFF">
          {me.wins}
        </CCText>
        <CCText fontSize={11} fontWeight="semibold" color={lbColors.darkText}>
          {metricWord}
        </CCText>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  stickyBar: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: lbColors.darkPanel,
    paddingHorizontal: 20,
    paddingVertical: 14,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 14,
  },
  stickyRank: {minWidth: 30, textAlign: 'center'},
  middle: {flex: 1},
  winsWrap: {alignItems: 'flex-end'},
});
